// Danske UI-strings — admin portal
// Alle bruger-vendte tekster skal komme herfra.

export const da = {
  // Auth
  auth: {
    login: 'Log ind',
    logout: 'Log ud',
    email: 'E-mail',
    password: 'Adgangskode',
    emailPlaceholder: 'din@email.dk',
    passwordPlaceholder: '••••••••',
    loginButton: 'Log ind',
    loggingIn: 'Logger ind...',
    loginError: 'Forkert e-mail eller adgangskode',
    required: 'Dette felt er påkrævet',
    invalidEmail: 'Ugyldig e-mail-adresse',
    passwordMin: 'Adgangskode skal være mindst 6 tegn',
    passwordMin8: 'Adgangskode skal være mindst 8 tegn',
    nameLabel: 'Fuldt navn',
    namePlaceholder: 'Jens Hansen',
    nameMin: 'Navn skal være mindst 2 tegn',
    companyLabel: 'Virksomhed',
    companyPlaceholder: 'Mitfirma ApS',
    companyMin: 'Virksomhedsnavn er påkrævet',
    signup: 'Opret konto',
    signingUp: 'Opretter...',
    signupSubtitle: 'Opret en ny konto',
    signupError: 'Noget gik galt. Prøv igen.',
    alreadyAccount: 'Har du allerede en konto?',
    loginLink: 'Log ind her',
    noAccountYet: 'Ingen konto endnu?',
    createAccountLink: 'Opret en her',
  },

  // Navigation
  nav: {
    dashboard: 'Overblik',
    properties: 'Ejendomme',
    companies: 'Virksomheder',
    leases: 'Lejemål',
    contracts: 'Lejeforhold',
    invoices: 'Opkrævninger',
    renters: 'Lejere',
    settings: 'Indstillinger',
    virksomhed: 'Virksomhed',
    financial: 'Økonomi',
    arrears: 'Restance',
    communications: 'Kommunikation',
    exports: 'Lister',
    listings: 'Annoncering',
  },

  // Annoncering (annoncer + ansøgere)
  listings: {
    title: 'Annoncering',
    subtitle: 'Fra ledigt lejemål til annonce, ansøgere og kontraktudkast',
    loading: 'Henter…',
    loadError: 'Kunne ikke hente annoncer.',
    empty: 'Ingen annoncer endnu. Opret en annonce for et ledigt lejemål.',
    create: 'Opret annonce',
    createTitle: 'Ny annonce',
    cancel: 'Annuller',
    save: 'Gem annonce',
    colTitle: 'Annonce',
    colLease: 'Lejemål',
    colRent: 'Husleje',
    colStatus: 'Status',
    colCreated: 'Oprettet',
    fieldLease: 'Lejemål',
    fieldLeasePlaceholder: 'Vælg lejemål',
    fieldTitle: 'Titel',
    fieldDescription: 'Beskrivelse',
    fieldRent: 'Husleje pr. måned (kr.)',
    errLease: 'Vælg et lejemål.',
    errTitle: 'Titel er påkrævet.',
    errRent: 'Angiv huslejen som et beløb, fx 9.500,00.',
    createError: 'Kunne ikke oprette annoncen.',
    noLeases: 'Der er ingen lejemål at annoncere. Opret først et lejemål.',
    status: { draft: 'Kladde', published: 'Udgivet', closed: 'Lukket' } as Record<string, string>,
    back: 'Tilbage til annoncer',
    notFound: 'Annoncen blev ikke fundet.',
    publish: 'Udgiv',
    close: 'Luk annonce',
    closeConfirm: 'Luk annoncen? En lukket annonce kan ikke ændres eller åbnes igen.',
    actionError: 'Handlingen kunne ikke gennemføres.',
    publishedAt: 'Udgivet',
    closedAt: 'Lukket',
    portalsTitle: 'Eksterne portaler – kommer',
    portalsBody: 'Kobling til eksterne boligportaler er ikke aktiv endnu. Annoncen er kun synlig her i Boligflow.',
    applicantsTitle: 'Ansøgere i venteliste',
    applicantsEmpty: 'Ingen ansøgere endnu.',
    colPos: 'Nr.',
    colName: 'Navn',
    colEmail: 'E-mail',
    colPhone: 'Telefon',
    colApplicantStatus: 'Status',
    colActions: 'Handlinger',
    addApplicant: 'Tilføj ansøger',
    applicantName: 'Navn',
    applicantEmail: 'E-mail',
    applicantPhone: 'Telefon (valgfri)',
    applicantNotes: 'Noter (valgfri)',
    errApplicantName: 'Navn er påkrævet.',
    errApplicantEmail: 'Angiv en gyldig e-mail-adresse.',
    addError: 'Kunne ikke tilføje ansøgeren.',
    closedNoAdd: 'Annoncen er lukket – der kan ikke tilføjes flere ansøgere.',
    moveUp: 'Flyt op',
    moveDown: 'Flyt ned',
    accept: 'Accepter',
    reject: 'Afvis',
    remove: 'Slet',
    removeConfirm: 'Slet ansøgeren? Ansøgeren fjernes fra ventelisten.',
    contractDraft: 'Opret kontraktudkast',
    applicantStatus: {
      ny: 'Ny',
      venteliste: 'Venteliste',
      accepteret: 'Accepteret',
      afvist: 'Afvist',
    } as Record<string, string>,
    forbidden: 'Du har ikke adgang til ansøgere. Kontakt en administrator.',
    kr: 'kr.',
  },

  // Dashboard
  dashboard: {
    title: 'Overblik',
    welcome: 'Hej,',
    subtitle: 'Her er dit overblik for i dag.',
    loading: 'Henter...',
    companies: {
      title: 'Nøgletal pr. selskab',
      filterLabel: 'Selskab',
      allCompanies: 'Alle selskaber',
      total: 'Samlet',
      colCompany: 'Selskab',
      colLeases: 'Lejemål',
      colOccupancy: 'Udlejningsgrad',
      colCollected: 'Opkrævet (denne måned)',
      colArrears: 'Restance',
      noData: 'Ingen data',
    },
  },

  // General
  general: {
    save: 'Gem',
    cancel: 'Annuller',
    delete: 'Slet',
    edit: 'Rediger',
    create: 'Opret',
    loading: 'Henter...',
    error: 'Noget gik galt. Prøv igen.',
    notFound: 'Siden blev ikke fundet.',
    backToHome: 'Tilbage til forsiden',
    yes: 'Ja',
    no: 'Nej',
  },

  // Boligflow brand
  brand: {
    name: 'Boligflow',
    tagline: 'Ejendomsadministration uden bøvl',
  },

  // Renters (lejere)
  renters: {
    title: 'Lejere',
    create: 'Opret lejer',
    name: 'Navn',
    email: 'E-mail',
    phone: 'Telefon',
    cpr: 'CPR-nummer',
    cprPlaceholder: '0101901234 (uden bindestreg)',
    cprHelp: 'CPR-nummeret krypteres og vises aldrig i klartekst.',
    partyKind: 'Lejertype',
    partyPerson: 'Privatperson',
    partySelskab: 'Selskab',
    cvr: 'CVR-nummer',
    cvrPlaceholder: '12345678',
    cvrLookup: 'Hent',
    cvrHelp: 'Vi henter selskabets navn, adresse, telefon og e-mail fra CVR-registret.',
    cvrInvalid: 'Indtast et gyldigt 8-cifret CVR-nummer.',
    hasDanishCvr: 'Har lejer dansk CVR-nummer?',
    hasDanishCvrHelp: 'Slå fra, hvis selskabet er udenlandsk og bruger et udenlandsk registreringsnummer. Så foretages der ikke CVR-opslag.',
    foreignReg: 'Udenlandsk registreringsnummer',
    foreignRegPlaceholder: 'Indtast registreringsnummer',
    selskabBadge: 'Selskab',
    personBadge: 'Person',
    address: 'Adresse',
    lease: 'Lejemål',
    status: 'Status',
    statusApplicant: 'Ansøger',
    statusActive: 'Aktiv',
    statusFormer: 'Tidligere',
    hasCpr: 'CPR registreret',
    noCpr: 'Intet CPR',
    noResults: 'Ingen lejere fundet.',
    createSuccess: 'Lejeren er oprettet.',
    createError: 'Kunne ikke oprette lejeren. Prøv igen.',
    namePlaceholder: 'Jens Hansen',
    emailPlaceholder: 'jens@example.dk',
    phonePlaceholder: '+45 12 34 56 78',
  },

  // Leases (lejemål)
  leases: {
    title: 'Lejemål',
    create: 'Opret lejemål',
    address: 'Adresse',
    unit: 'Enhed / dør',
    unitPlaceholder: '1. tv',
    type: 'Type',
    typeResidential: 'Lejlighed',
    typeCommercial: 'Erhverv',
    typeGarage: 'Garage/carport',
    typeStorage: 'Depotrum',
    usage: 'Anvendelse',
    usageBolig: 'Bolig',
    usageErhverv: 'Erhverv',
    usageGarage: 'Garage',
    usageLager: 'Lager',
    usageKontor: 'Kontor',
    usageKaelder: 'Kælder',
    usageAndet: 'Andet',
    renter: 'Lejer',
    monthlyRent: 'Månedsleje',
    status: 'Status',
    property: 'Ejendom',
    selectProperty: 'Vælg ejendom',
    noResults: 'Ingen lejemål fundet.',
    createSuccess: 'Lejemålet er oprettet.',
    createError: 'Kunne ikke oprette lejemålet. Prøv igen.',
    unassigned: '—',
    area: 'Areal (m²)',
    rooms: 'Værelser',
    floor: 'Etage',
    bbrFetching: 'Henter fra BBR …',
    bbrFound: 'Hentet fra BBR',
    bbrNotFound: 'Ingen BBR-data fundet for adressen — udfyld manuelt.',
    bbrUsageSuggested: 'foreslået fra BBR',
  },

  // Contracts / wizard (UI: "Lejeforhold")
  contracts: {
    title: 'Lejeforhold',
    create: 'Opret lejeforhold',
    noResults: 'Ingen lejeforhold fundet.',
    status: 'Status',
    statusDraft: 'Kladde',
    statusSent: 'Sendt',
    statusSigned: 'Underskrevet',
    statusActive: 'Aktiv',
    statusTerminated: 'Opsagt',
    type: 'Type',
    monthlyRent: 'Månedsleje',
    startDate: 'Indflytningsdato',
    // Legacy wizard steps (kept for backward compat with ContractListPage etc.)
    wizardStep1: 'Lejemål og lejer',
    wizardStep2: 'Lejevilkår',
    wizardStep3: '§ 11 klausuler',
    wizardStep4: 'Gennemse og send',
    selectLease: 'Vælg lejemål',
    selectRenter: 'Vælg lejer',
    monthlyRentLabel: 'Månedsleje (DKK)',
    depositLabel: 'Depositum (DKK)',
    prepaidRentLabel: 'Forudbetalt leje (DKK)',
    startDateLabel: 'Indflytningsdato',
    endDateLabel: 'Ophørsdato (tom = tidsubegrænset)',
    addClause: 'Tilføj klausul',
    clauseParagraph: 'Stykke nr.',
    clauseContent: 'Klausultekst',
    removeClause: 'Fjern',
    reviewTitle: 'Gennemse kontrakten',
    sendForSigning: 'Send til underskrift',
    sending: 'Sender...',
    sentConfirmation: 'Kontrakten er sendt til underskrift via MitID (Criipto)',
    sentSubtitle: 'Alle parter modtager en e-mail med underskriftslink.',
    back: 'Tilbage',
    next: 'Næste',
    finish: 'Afslut',
    // New Typeformular A wizard strings
    saveDraft: 'Gem kladde',
    saveDraftAndClose: 'Gem kladde & luk',
    preview: 'Forhåndsvis',
    previewContract: 'Forhåndsvis kontrakt',
    closePreview: 'Luk',
    printPreview: 'Udskriv',
    pickLease: 'Vælg lejemål',
    pickLeaseSubtitle: 'Vælg det lejemål kontrakten skal oprettes for',
    newTenancy: 'Nyt lejeforhold',
    newTenancyDesc: 'Opret en ny lejekontrakt fra bunden',
    existingTenancy: 'Eksisterende lejeforhold',
    existingTenancyDesc: 'Tilknyt en eksisterende kontrakt',
    comingSoon: 'Kommer snart',
    sectionGenerelt: '§1 Generelt',
    sectionOkonomi: '§3 Økonomi',
    sectionForsyning: '§5 Forsyning',
    sectionAntenne: '§6 Antenne / internet',
    sectionSyn: '§7 Syn',
    sectionVedligehold: '§8–9 Vedligehold',
    sectionVilkaar: '§10–11 Vilkår',
    sectionParter: 'Parter',
    sectionSend: 'Gennemse & send',
    leaseType: 'Lejemålstype',
    sublease: 'Fremleje',
    area: 'Areal (m²)',
    commercialArea: 'Erhvervsareal (m²)',
    rooms: 'Antal rum',
    fixedTerm: 'Tidsbegrænset lejeforhold',
    endDate: 'Slutdato',
    paymentDay: 'Betalingsdag',
    firstPayment: 'Første betaling',
    acontoHeating: 'Varme a conto',
    acontoWater: 'Vand a conto',
    acontoElectricity: 'El a conto',
    acontoCooling: 'Køling a conto',
    acontoAntenna: 'Antenne a conto',
    acontoInternet: 'Internet a conto',
    deposit: 'Depositum',
    prepaidRent: 'Forudbetalt leje',
    depositHelp: 'Depositum kan max. udgøre 3 måneders husleje (lejelovens §34)',
    heatingProvider: 'Varme leveres af',
    heatingType: 'Opvarmningsform',
    waterProvider: 'Vand leveres af',
    electricityProvider: 'El leveres af',
    coolingProvider: 'Køling leveres af',
    antennaIncluded: 'Fællesantenne inkluderet',
    antennaNotes: 'Kanaludbud / pakke',
    internetIncluded: 'Internet inkluderet',
    internetProvider: 'Udbyder',
    inspectionDate: 'Dato for indflytningssyn',
    inspectionTime: 'Tidspunkt',
    moveOutHelp: 'Fraflytningssyn afholdes senest 2 uger efter fraflytning, jf. lejelovens §98.',
    interiorMaintenance: 'Indvendig vedligeholdelse påhviler',
    maintenanceNotes: 'Særlig vedligeholdelsesaftale',
    inventoryNotes: 'Inventar og stand',
    beboerrepraesentation: 'Beboerrepræsentation',
    petsAllowed: 'Husdyr tilladt',
    petsNotes: 'Vilkår for husdyr',
    nettoprisindeks: 'Nettoprisindeks-regulering',
    nettoprisindeksYear: 'Basis-år',
    freeRent: 'Fri leje (lejelovens §54)',
    freeRentWarning: 'Kun muligt hvis ejendommen opfylder betingelserne i lejelovens §54',
    specialTerms: '§11 Særlige bestemmelser',
    landlord: 'Udlejer',
    tenant: 'Lejer',
    editInCompany: 'Rediger i Virksomhed →',
    addCoTenant: '+ Tilføj medlejer',
    stepOf: 'Trin',
    of: 'af',
  },
} as const

export type DaStrings = typeof da
